import ardennen from './img/ardennes.jpg';
import austria from './img/austria.jpg';
import cotedazur from './img/cotedazur.jpg';
import france from './img/france.jpg';
import ibiza from './img/ibiza.jpg';
import mallorca from './img/mallorca.jpg';
import spain from './img/spain.jpg';
import wellnesssuites from './img/wellnesssuites.jpg';
import luxemburg from './img/luxemburg.jpg';

export default {
  ardennen,
  austria,
  cotedazur,
  france,
  ibiza,
  mallorca,
  spain,
  wellnesssuites,
  luxemburg,
};
